import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

export type LockWarningDialogData = {
  userName: string;
};

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'ui-renta-lock-warning-dialog',
  templateUrl: 'lock-warning-dialog.component.html',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    MatButton,
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogTitle,
    MatIcon,
    MatIconButton,
    TranslatePipe,
  ],
})
export class LockWarningDialogComponent {
  protected readonly data = inject<LockWarningDialogData>(MAT_DIALOG_DATA);
}
